import { BlockComponentModel } from '@/components/cms/types/blok-component';

import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { PopupBanner } from './PopupBanner';

export type PopupBannerStrapiProps = {
  banner: {
    image?: ImageStrapiProps;
    title: string;
    description: RichTextFieldStrapiProps;
    cta?: LinkButtonStrapiProps;
  };
};

export const PopupBannerStrapiDC = ({
  block,
}: BlockComponentModel<PopupBannerStrapiProps>) => {
  const {
    banner: { image, cta, description, title },
  } = block;
  return (
    <PopupBanner
      image={
        !!image && (
          <ImageStrapi
            block={image}
            inner={{ classNames: { image: 'h-6 w-6' } }}
          />
        )
      }
      title={title}
      cta={
        !!cta && (
          <LinkButtonStrapi
            block={cta}
            inner={{ color: 'primary', classNames: { root: 'shrink-0' } }}
          />
        )
      }
      description={
        <RichTextFieldStrapi
          block={description}
          classNames={{
            paragraph: 'text-body-l text-gray-500',
          }}
        />
      }
    />
  );
};
